import type { MetricThresholdResource } from "@/types/api/MetricThreshold"

import type { MetricMetadata } from "./metadata"

export const FLOAT_COMPARISON_OPERATOR = {
  EQ: "eq",
  NEQ: "neq",
  GT: "gt",
  LT: "lt",
  GTE: "gte",
  LTE: "lte",
} as const

export type FloatComparisonOperator =
  (typeof FLOAT_COMPARISON_OPERATOR)[keyof typeof FLOAT_COMPARISON_OPERATOR]

export const SET_COMPARISON_OPERATOR = {
  IN: "in",
  NIN: "nin",
} as const

export type SetComparisonOperator =
  (typeof SET_COMPARISON_OPERATOR)[keyof typeof SET_COMPARISON_OPERATOR]

export type ComparisonOperator = FloatComparisonOperator | SetComparisonOperator

export const RANGE_COMPARISON_OPERATOR = {
  BT: "bt",
  NBT: "nbt",
} as const

export type TargetCondition =
  | {
      target_float: number
      comparison_operator: FloatComparisonOperator
    }
  | {
      target_values: string[]
      comparison_operator: SetComparisonOperator
    }

export interface MetricRecordData {
  metric_name: string
  metric_display_name: string
  metric_metadata: MetricMetadata
  description: string
  metric_manager: string
  locked: boolean
  category?: string
  created_at?: string
  id?: string
  organization_id?: string
  organization_slug?: string
  organization_display_name?: string
  created_by?: string
  last_updated_at?: string
  last_updated_by?: string
  active?: boolean
  output_type?: string
  tags?: string[]
  organization_threshold?: MetricThresholdResource | null
  /** ULID of the metric's current (live) version; null/undefined for metrics that predate versioning. */
  current_version_id?: string | null
  /** Human-facing number of the current version, used to detect stale metric outputs. */
  current_version_number?: number | null
  /**
   * True when this metric's manager extends LlmJudgeMetricBase on the backend.
   * Derived client-side from `metric_manager` via `isLlmJudgeManager` until
   * the backend transport-metrics view projects this server-side.
   */
  is_llm_judge?: boolean
}
